<template>
  <section id="legal" class="legal">
    <div class="container">
      <h2>合规与法律信息</h2>
      <div class="blocks">
        <div class="block">
          <h3>隐私政策（Privacy Policy）</h3>
          <p>我们仅收集实现功能所必需的数据，并提供目的说明、保存期限与删除路径。明确第三方共享范围与跨境传输原则。</p>
        </div>
        <div class="block">
          <h3>服务条款（Terms of Service）</h3>
          <p>列明许可范围与使用限制、知识产权、免责声明、责任限制及适用法律与争议解决方式。</p>
        </div>
        <div class="block">
          <h3>数据删除（Data Deletion）</h3>
          <p>用户可在应用或通过支持渠道提交删除请求；企业客户可通过管理员入口批量删除并获取审计记录。</p>
        </div>
        <div class="block">
          <h3>联系方式（Contact）</h3>
          <p>公司名称：加恒科技<br>地址：深圳市南山区科技园<br>合规/安全联络：<a href="mailto:jiahengljin@gmail.com">jiahengljin@gmail.com</a> · 数据保护：<a href="mailto:jiahengljin@gmail.com">jiahengljin@gmail.com</a></p>
        </div>
      </div>
      <div class="cta">
        <a href="#faq" class="btn">查看常见问题</a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Legal'
}
</script>

<style scoped>
.legal {
  padding: 64px 16px;
  background: #0f172a;
  color: #e5e7eb;
}
.container {
  max-width: 900px;
  margin: 0 auto;
}
.blocks {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}
.block {
  background: #111827;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 16px;
}
.block h3 {
  margin: 0 0 8px;
}
.cta {
  margin-top: 20px;
  text-align: center;
}
.btn {
  padding: 10px 16px;
  border-radius: 8px;
  color: #e5e7eb;
  text-decoration: none;
  border: 1px solid rgba(255, 255, 255, 0.2);
}
@media (max-width: 900px) {
  .blocks {
    grid-template-columns: 1fr;
  }
}
</style>



